import type { GetAssessmentActivityAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentActivityAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetAssessmentActivityAuditByIdArgs = {
  id: string;
};

export const useGetAssessmentActivityAuditById = createQueryHook<
  UseGetAssessmentActivityAuditByIdArgs,
  GetAssessmentActivityAuditByIdQuery['assessment_activity_audit'],
  GetAssessmentActivityAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.assessment.activityAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ assessment_activity_audit: data }),
  graphqlDocument: GetAssessmentActivityAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
